import { creatorbase } from '@round/api';

export const getPrimaryPaymentStatus = (paymentRequest: creatorbase.PostPaymentRequest) => {
    if (['CANCELLED'].includes(paymentRequest.status)) {
        return paymentRequest.status;
    }

    if (paymentRequest.provider_name === 'PAYPAL' && paymentRequest.paypal_transaction_status) {
        return paymentRequest.paypal_transaction_status;
    }

    if (paymentRequest.provider_name === 'TIPALTI' && paymentRequest.tipalti_transaction_status) {
        return paymentRequest.tipalti_transaction_status;
    }

    return paymentRequest.status;
};
